import {Divider} from 'src/design/atoms/Divider';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

interface FormStaticV2Props {
  field: IFormFieldV2;
}

export const FormDividerV2 = React.memo<FormStaticV2Props>(() => {
  return <Divider />;
});
